import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3h-4v6h4","key":"svg-0"}],["path",{"d":"M10 6h2.5","key":"svg-1"}],["path",{"d":"M16 21l-4 -8l-4 8l4 -2l4 2","key":"svg-2"}]]

/**
 * IconNavigationEast
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbmF2aWdhdGlvbi1lYXN0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNCAzaC00djZoNCIgLz4KICA8cGF0aCBkPSJNMTAgNmgyLjUiIC8+CiAgPHBhdGggZD0iTTE2IDIxbC00IC04bC00IDhsNCAtMmw0IDIiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/navigation-east
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNavigationEast = createReactComponent('outline', 'navigation-east', 'NavigationEast', __iconNode);

export default IconNavigationEast;